import get from 'lodash.get';
import createCachedSelector from 're-reselect';

import { emptyObject, emptyArray } from 'ui-components/default-props/empty';

const selectReturns = (state) => get(state, 'returns', emptyObject);
export const selectReturnById = (state, props) => get(selectReturns(state, props), props.fulfillmentId);

export const selectReturnsByIds = createCachedSelector(
  selectReturns,
  (_, { fulfillmentIds }) => fulfillmentIds,
  (returns, fulfillmentIds) => {
    if (fulfillmentIds.length === 0) {
      return emptyArray;
    }

    return fulfillmentIds.map((fulfillmentId) => returns[fulfillmentId]);
  },
)((_, { fulfillmentIds }) => JSON.stringify(fulfillmentIds));
